/* Secure Funding America / theme.js (Prism)
   Pure vanilla JS. First statement gates all hidden states behind html.js
   so no-JS users and crawlers always see full content. */
document.documentElement.classList.add("js");

(function () {
  "use strict";

  var reduceMotion = false;
  if (window.matchMedia) {
    reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  }

  function ready(fn) {
    if (document.readyState !== "loading") {
      fn();
    } else {
      document.addEventListener("DOMContentLoaded", fn);
    }
  }

  /* ---------- Word-pop splitter ----------
     Wraps each word in a .wd span with a --w stagger index. Elements like
     .mark and .rotator are preserved intact and treated as single units.
     Hidden state only applies after data-split="done", so an unsplit
     heading is never hidden. */
  function splitWords(el) {
    if (reduceMotion) return;
    if (el.getAttribute("data-split") === "done") return;

    var w = 0;
    function wrapNode(node, parent) {
      if (node.nodeType === 3) {
        var words = node.textContent.split(/(\s+)/);
        var frag = document.createDocumentFragment();
        words.forEach(function (piece) {
          if (!piece) return;
          if (/^\s+$/.test(piece)) {
            frag.appendChild(document.createTextNode(" "));
          } else {
            var s = document.createElement("span");
            s.className = "wd";
            s.style.setProperty("--w", w++);
            s.textContent = piece;
            frag.appendChild(s);
          }
        });
        parent.replaceChild(frag, node);
      } else if (node.nodeType === 1) {
        if (node.classList.contains("rotator")) {
          // treat the whole rotator as one popping unit
          var wrap = document.createElement("span");
          wrap.className = "wd";
          wrap.style.setProperty("--w", w++);
          parent.replaceChild(wrap, node);
          wrap.appendChild(node);
        } else if (node.classList.contains("mark")) {
          // pop the mark's words but keep the mark element (its ::before
          // draws the highlighter after the words land)
          Array.prototype.slice.call(node.childNodes).forEach(function (child) {
            wrapNode(child, node);
          });
        }
      }
    }

    Array.prototype.slice.call(el.childNodes).forEach(function (node) {
      wrapNode(node, el);
    });
    el.setAttribute("data-split", "done");
  }

  function playWords(el) {
    // Double rAF so the hidden state paints before the transition starts
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        el.classList.add("is-played");
        var words = el.querySelectorAll(".wd").length;
        setTimeout(function () {
          el.classList.add("is-marked");
        }, Math.min(words * 65 + 350, 1400));
      });
    });
  }

  /* ---------- Rotating word swap (hue-cycled) ---------- */
  function initRotator(rot) {
    var words = rot.querySelectorAll(".rotator__word");
    if (words.length < 2 || reduceMotion) {
      if (words.length) words[0].classList.add("is-current");
      return;
    }
    var maxW = 0;
    words.forEach(function (word) { maxW = Math.max(maxW, word.offsetWidth); });
    if (maxW > 0) rot.style.minWidth = maxW + "px";

    var idx = 0;
    words[0].classList.add("is-current");
    setInterval(function () {
      var current = words[idx];
      idx = (idx + 1) % words.length;
      var next = words[idx];
      current.classList.remove("is-current");
      current.classList.add("is-leaving");
      next.classList.remove("is-leaving");
      void next.offsetWidth;
      next.classList.add("is-current");
      setTimeout(function () { current.classList.remove("is-leaving"); }, 650);
    }, 2600);
  }

  /* ---------- Confetti backdrop spawner ---------- */
  var HUES = ["coral", "violet", "amber", "teal"];
  var SHAPES = ["dot", "ring", "tri", "plus"];
  function spawnConfetti(zone, dark) {
    if (reduceMotion) return;
    var count = parseInt(zone.getAttribute(dark ? "data-confetti-dark" : "data-confetti"), 10) || 8;
    var field = document.createElement("div");
    field.className = "confetti";
    field.setAttribute("aria-hidden", "true");
    for (var i = 0; i < count; i++) {
      var cf = document.createElement("i");
      cf.className = "cf cf--" + SHAPES[i % SHAPES.length] + " cf--" + HUES[(i + Math.floor(i / 4)) % HUES.length];
      cf.style.left = (4 + Math.random() * 92) + "%";
      cf.style.top = (4 + Math.random() * 88) + "%";
      cf.style.setProperty("--cf-x", (Math.random() * 44 - 22).toFixed(0) + "px");
      cf.style.setProperty("--cf-y", (Math.random() * 44 - 22).toFixed(0) + "px");
      cf.style.setProperty("--cf-r", (Math.random() * 90 - 45).toFixed(0) + "deg");
      cf.style.setProperty("--cf-dur", (9 + Math.random() * 8).toFixed(1) + "s");
      cf.style.setProperty("--cf-delay", (-Math.random() * 9).toFixed(1) + "s");
      if (dark) cf.style.opacity = "0.35";
      cf.style.scale = (0.7 + Math.random() * 0.8).toFixed(2);
      field.appendChild(cf);
    }
    zone.insertBefore(field, zone.firstChild);
  }

  /* ---------- Spectrum Match Board ---------- */
  function dealBoard(root) {
    var cards = root.querySelectorAll("[data-board-card]");
    cards.forEach(function (card, i) {
      setTimeout(function () {
        card.classList.add("is-dealt");
      }, reduceMotion ? 0 : 320 + i * 240);
    });
  }

  ready(function () {
    /* Capsule shrink + mobile nav */
    var header = document.querySelector("[data-header]");
    if (header) {
      var onScroll = function () {
        header.classList.toggle("is-shrunk", window.scrollY > 40);
      };
      window.addEventListener("scroll", onScroll, { passive: true });
      onScroll();
    }
    var toggle = document.querySelector("[data-nav-toggle]");
    var mobileNav = document.querySelector("[data-mobile-nav]");
    if (toggle && mobileNav) {
      toggle.addEventListener("click", function () {
        var open = mobileNav.classList.toggle("is-open");
        toggle.classList.toggle("is-active", open);
        toggle.setAttribute("aria-expanded", open ? "true" : "false");
        mobileNav.style.maxHeight = open ? mobileNav.scrollHeight + "px" : "0px";
      });
    }

    /* FAQ accordion */
    document.querySelectorAll("[data-faq-toggle]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var answer = btn.parentElement.querySelector("[data-faq-answer]");
        var expanded = btn.getAttribute("aria-expanded") === "true";
        btn.setAttribute("aria-expanded", expanded ? "false" : "true");
        if (answer) answer.classList.toggle("is-open", !expanded);
      });
    });

    /* Confetti fields */
    document.querySelectorAll("[data-confetti]").forEach(function (zone) {
      spawnConfetti(zone, false);
    });
    document.querySelectorAll("[data-confetti-dark]").forEach(function (zone) {
      spawnConfetti(zone, true);
    });

    /* Split headings */
    var loadHeads = document.querySelectorAll("[data-words-load]");
    var scrollHeads = document.querySelectorAll("[data-words]");
    loadHeads.forEach(splitWords);
    scrollHeads.forEach(splitWords);

    /* Above-the-fold: fire on load, never wait for scroll */
    loadHeads.forEach(playWords);

    /* Rotator */
    document.querySelectorAll("[data-rotator]").forEach(initRotator);

    /* IntersectionObserver choreography */
    var revealables = document.querySelectorAll(".reveal, [data-words], [data-board], [data-meter], [data-map], .img-unfold");
    if (!("IntersectionObserver" in window) || reduceMotion) {
      revealables.forEach(function (el) {
        el.classList.add("is-visible");
        if (el.hasAttribute("data-words")) { el.classList.add("is-played"); el.classList.add("is-marked"); }
        if (el.hasAttribute("data-board")) dealBoard(el);
        if (el.hasAttribute("data-meter")) el.classList.add("is-filled");
      });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        el.classList.add("is-visible");
        if (el.hasAttribute("data-words")) playWords(el);
        if (el.hasAttribute("data-board")) dealBoard(el);
        if (el.hasAttribute("data-meter")) el.classList.add("is-filled");
        io.unobserve(el);
      });
    }, { rootMargin: "0px 0px -12% 0px", threshold: 0.15 });

    revealables.forEach(function (el) { io.observe(el); });
  });
})();
